(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-1"] && !Shopify.designMode) return;
  try {
    // ===== Product Card Image Slider =====
(function () {
  function initSlider(slider) {
    const track = slider.querySelector('[data-slider-track]');
    const slides = slider.querySelectorAll('[data-slide]');
    const prevBtn = slider.querySelector('[data-slider-prev]');
    const nextBtn = slider.querySelector('[data-slider-next]');
    const dots = slider.querySelectorAll('[data-dot]');

    if (!track || slides.length <= 1) return;

    slider.setAttribute('data-total', slides.length);

    let current = 0;
    let startX = 0;
    let isDragging = false;

    function goTo(index) {
      current = (index + slides.length) % slides.length;
      track.style.transform = `translateX(-${current * 100}%)`;
      dots.forEach((d, i) => d.classList.toggle('is-active', i === current));
    }

    prevBtn && prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      goTo(current - 1);
    });

    nextBtn && nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      goTo(current + 1);
    });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => goTo(parseInt(dot.dataset.dot)));
    });

    // Touch/Swipe support
    slider.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    }, { passive: true });

    slider.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
      isDragging = false;
    });

    // Mouse drag support
    slider.addEventListener('mousedown', (e) => {
      startX = e.clientX;
      isDragging = true;
    });

    slider.addEventListener('mouseup', (e) => {
      if (!isDragging) return;
      const diff = startX - e.clientX;
      if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
      isDragging = false;
    });

    // Prevent link click on drag
    slider.addEventListener('click', (e) => {
      if (Math.abs(startX - e.clientX) > 10) e.preventDefault();
    });
  }

  function initAllSliders() {
    document.querySelectorAll('[data-slider]').forEach(initSlider);
  }

  // Init on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSliders);
  } else {
    initAllSliders();
  }

  // Re-init for dynamically loaded content (infinite scroll, filters, etc.)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      m.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        node.querySelectorAll && node.querySelectorAll('[data-slider]').forEach(initSlider);
        if (node.matches && node.matches('[data-slider]')) initSlider(node);
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();





// ===========devS========

// document.addEventListener('click', function(e) {
//   const btn = e.target.closest('.m-info-cart-btn');
//   if (!btn) return;

//   e.preventDefault();

//   const variantId = btn.dataset.variantId;

//   fetch('/cart/add.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     body: JSON.stringify({
//       id: variantId,
//       quantity: 1
//     })
//   })
//   .then(res => res.json())
//   .then(() => {
//     document.dispatchEvent(new CustomEvent('cart:refresh'));
//   })
//   .catch(err => console.error(err));
// });





document.addEventListener('click', function(e) {
  const btn = e.target.closest('.m-info-cart-btn');
  if (!btn) return;

  e.preventDefault();

  const variantId = btn.dataset.variantId;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
  .then(res => res.json())
  .then(() => {
    // Pass open: true — onCartRefresh will refresh cart AND then call cartElement.open()
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
  })
  .catch(err => console.error(err));
});
  } catch(e) { console.error(e); }
})();

})();
